import { generateUUID } from 'app/shared/uuid.service';

export class WaitableSingleUseDOMEvent {
    _dispatched: boolean;
    _event: Event;
    _promise: Promise<void>;

    /**
     * A WaitableEvent wraps up an Event and a Promise with a convenient API
     * @param prefix if given, the Event.type will be a UUID prefixed with this string
     * @param typeOverride if given, the Event.type will be this string
     */
    constructor(prefix: string = null, typeOverride: string = null) {
        let type: string;
        if (typeOverride) {
            type = typeOverride;
        } else {
            type = prefix ? `${prefix}-${generateUUID()}` : generateUUID();
        }

        this._dispatched = false;
        this._event = new Event(type);
        this._promise = new Promise((resolve) => {
            addEventListener(this._event.type, () => {
                resolve();
            });
        });
    }

    /**
     * Dispatch the internal event or fallthrough if that's already happened
     */
    public async dispatch(): Promise<void> {
        if (this._dispatched) {
            return;
        }

        await dispatchEvent(this._event);
        this._dispatched = true;
    }

    /**
     * Return a promise that will resolve when the internal event is dispatched or fallthrough if
     * that's already happened
     */
    public async wait(): Promise<void> {
        if (this._dispatched) {
            return Promise.resolve();
        }

        return await this._promise;
    }
}
